import { useEffect, useMemo, useState } from "react";

export default function useOnScreen(ref, initialState = false) {
  const [isIntersecting, setIntersecting] = useState(initialState);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting)
      ),
    [ref]
  );

  useEffect(() => {
    if (ref) observer.observe(ref);
    return () => observer.disconnect();
  }, [ref]);

  return isIntersecting;
}
